import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'sl-profile-list-no-results',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './profile-list-no-results.component.html',
  styleUrl: './profile-list-no-results.component.scss',
})
export class ProfileListNoResultsComponent {
  type = input<'no_results' | 'page_limit_reached'>('no_results');

  pageChange = output<number>();
}
